import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';
import { Layers } from 'lucide-react';

/**
 * Replaces `page:catalog-unprocessed-entities` from
 * `@backstage/plugin-catalog-unprocessed-entities` with a Tailwind/shadcn page
 * (ADR-0012). The stock page is `@backstage/ui` chrome around two
 * material-table grids — an eight-column table with an underlined filter
 * input, a bright blue "no results" alert in the table body and errors hidden
 * behind a row expander — which is the same drift from the rest of the portal
 * as the notifications, catalog and api-docs overrides.
 *
 * `title` and `icon` have to be repeated here: `PageBlueprint` only emits
 * `core.title` / `core.icon` when the params carry them, and the sidebar's
 * Admin section is built from `navItems.take('page:catalog-unprocessed-entities')`
 * — so dropping them would drop the nav entry.
 */
export const unprocessedEntitiesModule = createFrontendModule({
  pluginId: 'catalog-unprocessed-entities',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/catalog-unprocessed-entities',
        title: 'Unprocessed Entities',
        icon: <Layers aria-hidden="true" className="size-4" />,
        noHeader: true,
        routeRef: createRouteRef({
          aliasFor: 'catalog-unprocessed-entities.root',
        }),
        loader: () =>
          import('./VivictaUnprocessedEntitiesPage').then(m => (
            <PageErrorBoundary title="Unprocessed Entities">
              <m.VivictaUnprocessedEntitiesPage />
            </PageErrorBoundary>
          )),
      },
    }),
  ],
});
